"use client";

import { ReactNode } from "react";
import { Button } from "@vionixasia/shared-components";

export function ConfirmationModal({
  open,
  title,
  children,
  confirmLabel = "Confirm",
  onCancel,
  onConfirm,
}: {
  open: boolean;
  title: string;
  children: ReactNode;
  confirmLabel?: string;
  onCancel: () => void;
  onConfirm: () => void;
}) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4">
      <div className="w-full max-w-md rounded-card border border-line bg-white p-5">
        <h2 className="text-lg font-semibold text-ink">{title}</h2>
        <div className="mt-3 text-sm text-muted">{children}</div>
        <div className="mt-6 flex justify-end gap-2">
          <Button variant="muted" onClick={onCancel}>
            Cancel
          </Button>
          <Button color="teal" onClick={onConfirm}>
            {confirmLabel}
          </Button>
        </div>
      </div>
    </div>
  );
}
